export default interface Margin {
    top: number;
    left: number;
    bottom: number;
    right: number
};
export const NO_MARGIN: Margin = {top: 0, left: 0, bottom: 0, right: 0};
export const MINIMAL_MARGIN: Margin = {top: 1, left: 1, bottom: 1, right: 1};

